import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const defaultAdvertiserProfile: FaireAdvertiserProfileEntity = {
  token: "default",
  type: "advertiserProfile",
  archetype: "median-budget-median-results",
  displayName: "Default Advertiser",
  brandToken: "default",
  audienceType: "NEW_ONLY",
  globalStatus: "NOT_STARTED",
  budget: {
    totalBudgetDollars: 0,
  },
  overview: {
    numCustomersAcquired: 0,
    numReorderConversions: 0,
    numTotalConversions: 0,
    totalAdsSalesDollars: 0,
    totalAdsSpendDollars: 0,
  },
  campaignTokens: [],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
